import Axios from 'axios'
import config from './config'

const apiUrls = {
  remote: config.passesRemoteApiUrl,
  local: config.passesLocalApiUrl
}

const syncPasses = async ({ apiSource, apiKey, templateId }) => {
  try {
    let options = {
      method: 'POST',
      url: `${apiUrls[apiSource]}/syncPasses/${templateId}/true` // true = sync to Apple devices
    }

    const result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return { ok: false, error: err.response?.data?.error?.message ?? "Error synchronising pass" }
  }
}


const makePass = async ({ apiSource, apiKey, apiMode, templateId, passId, passData }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/makePass/${templateId}/${passId}`,
      method: "PUT",
      data: passData
    }

    let result = await callApi({ apiKey, apiMode, options })

    return result
  }
  catch (err) {
    console.error(err)
    return { ok: false, error: err.response?.data?.error?.message ?? "Error making pass" }
  }
}

const getIssuedPasses = async ({ apiSource, apiKey, templateId, mode, startRow, maxRows }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getIssuedPasses/${templateId}/${startRow}/${maxRows}`,
      method: "GET"
    }

    let result = await callApi({ apiKey, apiMode: mode, options })

    return result
  }
  catch (err) {
    console.error(err)
    return { ok: false, error: err.response?.data?.error?.message ?? "Error getting passes list" }
  }
}

const getPass = async ({ apiSource, apiKey, templateId, passId }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getPass/${templateId}/${passId}`,
      method: "GET"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return { ok: false, error: (err.response?.data?.error?.message ?? "Error getting pass") }
  }
}


const updatePass = async ({ apiSource, apiKey, templateId, passId, instance_data, scanner_instance_data }) => {
  try {
      let options = {
        url: `${apiUrls[apiSource]}/updatePass/${templateId}/${passId}/true`, // true = push changes to Apple devices]
        method: "PUT",
        data: {
          instance_data,
          scanner_instance_data
        }
      }

      let result = await callApi({ apiKey, options })

      return result

  }
  catch (err) {
    console.error(err)
    return { ok: false, error: (err.response?.data?.error?.message ?? "Error updating pass") }
  }
}

const getPassNotifications = async ({ apiSource, apiKey, templateId, passId }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getPassNotifications/${templateId}/${passId}`,
      method: "GET"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return { ok: false, error: err.response?.data?.error?.message ?? "Error getting notifications" }
  }
}

const notifyPass = async ({ apiSource, apiKey, templateId, passId, notification }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/notifyPass/${templateId}/${passId}`,
      method: "POST",
      data: { notification }
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return { ok: false, error: err.response?.data?.error?.message ?? "Error notifying pass" }
  }
}

const notifyPasses = async ({ apiSource, apiKey, templateId, passes, notification }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/notifyPasses/${templateId}`,
      method: "POST",
      data: {
        pass_ids: passes,
        notification
      }
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return { ok: false, error: err.response?.data?.error?.message ?? "Error notifying passes" }
  }
}

const notifyAll = async ({ apiSource, apiKey, templateId, notification }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/notifyAll/${templateId}`,
      method: "POST",
      data: { notification }
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return { ok: false, error: err.response?.data?.error?.message ?? "Error notifying passes" }
  }
}



const getActivePassesCount = async ({ apiSource, apiKey }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getActivePassesCount`,
      method: "get"
    }

    let result = await callApi({ apiKey, apiMode: "live", options })

    return result
  }
  catch (err) {
    console.error(err)
    console.error(err)
    return { ok: false, error: err.response?.data?.error?.message ?? "Error getting pass counts" }
  }
}

const deletePasses = async ({ apiSource, apiKey, apiMode, templateId, passes }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/deletePasses/${templateId}`,
      method: "delete",
      data: { passes }
    }

    let result = await callApi({ apiKey, apiMode, options })

    return result
  }
  catch (err) {
    console.error(err)
    return { ok: false, error: err.response?.data?.error?.message ?? "Error deleting pass" }
  }
}


const callApi = async ({ apiKey, apiMode, options }) => {
  try {
      options.headers = {
        'x-api-key': apiKey,
        'x-mode' : apiMode,
        'Content-type': 'application/json',
      }

    let response = await Axios(options)

    return response.data
  }
  catch (err) {
    throw err
  }
}


export {
  getActivePassesCount,
  getPass,
  getIssuedPasses,
  getPassNotifications,
  makePass,
  notifyAll,
  notifyPass,
  notifyPasses,
  syncPasses,
  updatePass,
  deletePasses,
}